module.exports = __webpack_public_path__ + "static/media/HSBC.2e545b90.jpg";